import { render, staticRenderFns } from "./Anulare.vue?vue&type=template&id=23aaea96&scoped=true&"
import script from "./Anulare.vue?vue&type=script&lang=js&"
export * from "./Anulare.vue?vue&type=script&lang=js&"
import style0 from "./Anulare.vue?vue&type=style&index=0&id=23aaea96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aaea96",
  null
  
)

export default component.exports